import { HTTPv2, Service } from '@/services/config'

class AssetLocationServiceV2 extends Service {
  constructor() {
    super(HTTPv2)
  }

  async integrateIndividualVehiclePlate(params: any) {
    const httpResponse = await this.httpClient.post(
      'veiculo/integrarPlacaIndividual',
      params
    )
    return httpResponse
  }
}

export const assetLocationServiceV2 = new AssetLocationServiceV2()
